module.exports = __webpack_public_path__ + "img/scenario-moba.f776cdf.svg";